module.exports = __webpack_public_path__ + "videos/video-premium-benefit-list.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video/premium/video-premium-benefit-list.mp4
// module id = 977
// module chunks = 1